export
    ///////////////////////////////////////////
    // START - PRETTY PERCENTAGE LIB
    ///////////////////////////////////////////
    function getPrettyPercentages (responsesPerAnswer) {
      // PREPARE DATA...

      // Vote counts sorted by rank in the set of unique vote counts. E.g., Votes of [6, 4, 4, 23] becomes [23, 6, 4]
      var originalRanksByVotes = getRanks(responsesPerAnswer);
      // Array of "results" objects sorted by original answer index. [{index: 0, votes: 84, rank: 1, percentage: 84},...]
      var originalResults = createResults(responsesPerAnswer, originalRanksByVotes);
      // Array of "results" objects that will be modified to contain the "pretty" percentages.
      var proposedResults = createResults(responsesPerAnswer, originalRanksByVotes);
      // A ledger indicating which answers had which vote counts, sorted by vote-count ascending. E.g., // [{votes: 0, answers: [3,4]}, {votes: 2, answers: [1,5]},...]
      // This ledger allows the algorithm to process ties as a group when attempting to increase percentage counts to total 100 percent.
      var answersGroupedByVotes = getAnswersGroupedByVotes(responsesPerAnswer);

      // PROCESS DATA...

      // First, seed the percentages by ranking. Treat each of the "100" percentage integer as a point
      // to be awarded. Start by awarding 0 points for answers with 0 votes, 1 point for answers in
      // last place, 2 points for answers in "last place - 1", and so on until all answers have been
      // awarded the appropriate number of "points" for their position in the rankings. In cases where
      // there are too many individual positions in the rankings to be able to award each position
      // a unique number of percentage points that total <= 100: for each answer, use the floored integer
      // percentage result of "votes received / total votes". For example, consider a question with
      // 30 answers, each of which has a unique position in the rankings (from 1 to 30). Totalling all
      // numbers from 1 to 30 would exceed the 100 percentage points available, so each answer is simply
      // assigned its "natural" votes/totalVotes floored percentage. In cases where all rankings can be
      // reflected within the 100 points available, issuePointsForRank() forces the correct rankings
      // for the percentage representation of the vote counts, even if that representation does not
      // accurately reflect the mathematically correct integer percentage. In other words,
      // issuePointsForRank() "pads" percentages until they match the rankings by raw votes.
      // E.g.,  issuePointsForRank([20, 33, 7])
      //          Returns: [2,3,1]
      issuePointsForRank(originalResults, proposedResults, answersGroupedByVotes.length, answersGroupedByVotes[0].votes);

      // After "points for rankings" have been assigned, allot remaining percentage
      // points as follows:
      //   1) Add one point to each answer as long as each answer's percentage
      //      does not exceed "natural" percentage
      //   2) When no more points can be given out without any one answer's
      //      percentage exceeding its "natural" percentage, allot "surplus"
      //      percentage points to any answer whose ranking would not change if
      //      its percentage were increased, in order from most-to-least popular
      //      answer.
      distributeRemainingPoints(originalResults, proposedResults, answersGroupedByVotes, originalRanksByVotes);

      /*
      log("ORIGINAL VOTES:");
      traceProp(originalResults, "votes");
      log("PROPOSED PERCENTAGES:");
      traceProp(proposedResults, "percentage");
      log("ORIGINAL PERCENTAGES:");
      traceProp(originalResults, "percentage");

      log("SUM: " + sum(getPercentagesFromResults(proposedResults)));
      log("Proposed Num Answers:" + proposedResults.length + ", Original Num Answers: " + responsesPerAnswer.length);
      */

      // Return flat array of final percentages
      return getPercentagesFromResults(proposedResults);
    }

//==============================================================================
// PREPARE DATA
//==============================================================================

    // Returns a copy of the specified array, ranked densely in descending order.
    // Assumes all elements are numbers. Example:
    //   getRanks([98, 34, 105, 105, 627])
    //     Returns:   [627, 105, 98, 34]
    function getRanks (array) {
      var uniques = unique(array);
      var sorted = uniques.slice().sort(function(a,b){return b-a;});
      return sorted;
    }

    // Returns a list of "result" objects specifying the following information
    // for each answer in the question:
    //   -index: the answer's original index in the question
    //   -votes: the number of raw votes the answer received
    //   -rank: the dense ranking by number of raw votes (NOT percentage)
    //   -percentage: the percentage of the total votes cast for this answer,
    //                calculated as Math.floor(votes/totalvotes)
    // The list is sorted by the original order of the answers (options) in
    // the question.
    function createResults (responsesPerAnswer, originalRanksByVotes) {
      var results = [];
      var percentages = toFlooredIntegerPercentages(responsesPerAnswer);
      var len = responsesPerAnswer.length;

      for (var i = 0; i < len; i++) {
        results[i] = {
          "index": i,
          "votes": responsesPerAnswer[i],
          "rank": originalRanksByVotes.indexOf(responsesPerAnswer[i]) + 1,
            "percentage": percentages[i]
        };
      }

      return results;
    }

    // Returns an array of objects specifying which answers received each unique
    // vote count. The array is sorted by number of votes, ascending.
    // For example, given votes of [33,2,45,0,0,2], returns:
    //   [{votes: 0, answers: [3,4]},
    //    {votes: 2, answers: [1,5]},
    //    {votes: 33, answers: [0]},
    //    {votes: 45, answers: [2]}]
    function getAnswersGroupedByVotes (responsesPerAnswer) {
      var answersGroupedByVotes = [];
      var voteCountIndex;

      for (var i = 0; i < responsesPerAnswer.length; i++) {
        voteCountIndex = indexOf(answersGroupedByVotes, "votes", responsesPerAnswer[i]);

        if (voteCountIndex == -1) {
          answersGroupedByVotes.push({"votes": responsesPerAnswer[i],
            "answers": [i]});
        } else {
          answersGroupedByVotes[voteCountIndex].answers.push(i);
        }
      }
      sortByProp(answersGroupedByVotes, "votes", true);
      return answersGroupedByVotes;
    }

//==============================================================================
// PROCESS DATA
//==============================================================================

    // Award initial percentage "points" for rankings. For example, the set of
    // votes [20, 33, 7] would result in the initial percentages [2,3,1]. Do
    // not award any points for answers that received zero votes.
    function issuePointsForRank (originalResults, proposedResults, lastPlaceRank, lastPlaceVoteCount) {
      for (var i = 0; i < proposedResults.length; i++) {
        proposedResults[i].percentage = (lastPlaceVoteCount == 0 ? 0 : 1) + (lastPlaceRank - (originalResults[i].rank));
      }

      // If the rankings cannot be reflected within the granularity of 100 percent,
      // then use the original percentages calculated by flooring
      // votesForThisAnswer/votesForAllAnswers.
      if (sum(getPercentagesFromResults(proposedResults)) > 100) {
        // Sum of "rank respecting" percentages exceeds 100, which means there
        // are more ranks than can be expressed with integer percentages, so
        // abort "rank respecting" percentages and just use traditional
        // "votes/totalvotes" percentages.
        for (var j = 0; j < proposedResults.length; j++) {
          proposedResults[j].percentage = originalResults[j].percentage;
        }
      }
    }

    // After points are alloted for ranking, give out remaining points until
    // all answer percentages total 100, or answer percentages cannot be
    // increased without affecting rankings.
    function distributeRemainingPoints (originalResults, proposedResults, answersGroupedByVotes, originalRanksByVotes) {
      var remainingPoints = 100;
      for (var i = proposedResults.length; --i >=0 ;) {
        remainingPoints -= proposedResults[i].percentage;
      }

      // log("POINTS REMAINING PRE DISTRIBUTION: " + remainingPoints);

      var result;
      var answerIndex;
      var thisAnswerGroup;
      var pointsAdded;

      // FIRST PASS: UP TO FLOORED PERCENTAGES
      // First distribute points up to the original floored percentages for
      // each answer. If there is a surplus of points after reaching all floored
      // percentages, distribute that surplus later.
      do {
        pointsAdded = 0;
        // For this group of answers...
        for (var j = 0; j < answersGroupedByVotes.length; j++) {
          thisAnswerGroup = answersGroupedByVotes[j];
          // log("\n");
          // log(j + ") Num Answers in Group: " + thisAnswerGroup.answers.length + ", Points Remaining: " + remainingPoints);
          // Allot one point to each answer in this answer group UP TO THE
          // ORIGINAL FLOORED PERCENTAGE, unless:
          //   -The answer group has zero votes
          //   -The answer group is a tie and there aren't enough points
          //    to give one to every answer in the tie
          if (thisAnswerGroup.votes != 0
            && thisAnswerGroup.answers.length <= remainingPoints) {
            for (var k = 0; k < thisAnswerGroup.answers.length; k++) {
              answerIndex = indexOf(proposedResults, "index", thisAnswerGroup.answers[k]);
              result = proposedResults[answerIndex];
              if (result.percentage + 1 <= originalResults[answerIndex].percentage) {
                // log("Added one to " + result.votes);
                result.percentage += 1;
                remainingPoints--;
                pointsAdded++;
              }
            }
            // Check if rankings have changed. If so, revert point allotment.
            var reversionResult = revertPointsThatChangeRankings(proposedResults, thisAnswerGroup, originalRanksByVotes, pointsAdded, remainingPoints);
            pointsAdded = reversionResult.pointsAdded;
            remainingPoints = reversionResult.remainingPoints;

          }
        }
      } while (remainingPoints > 0 && pointsAdded > 0);
      // log("POINTS REMAINING POST DISTRIBUTION: " + remainingPoints);

      // SECOND PASS: UNTIL ALL POINTS HAVE BEEN ALLOTED OR
      //              CAN NO LONGER BE ALLOTED WITHOUT BREAKING RANKINGS
      // If there is a surplus of points remaining after initial distribution,
      // attempt to distribute that surplus now, from most-popular to
      // least-popular answer. Do not allot any given point that would change
      // rankings.
      do {
        // log(remainingPoints + " POINTS SURPLUS REMAINING. ATTEMPTING TO DISTRIBUTE...");
        pointsAdded = 0;
        for (var n = answersGroupedByVotes.length; --n >= 0; ) {
          thisAnswerGroup = answersGroupedByVotes[n];
          // Allot one point to each answer in this answer group unless:
          //   -The answer group has zero votes
          //   -The answer group is a tie and there aren't enough surplus points
          //    to give one to every answer in the tie
          if (thisAnswerGroup.votes != 0
            && thisAnswerGroup.answers.length <= remainingPoints) {
            for (var o = 0; o < thisAnswerGroup.answers.length; o++) {
              answerIndex = indexOf(proposedResults, "index", thisAnswerGroup.answers[o]);
              result = proposedResults[answerIndex];
              // log("Added one to " + result.votes);
              result.percentage += 1;
              remainingPoints--;
              pointsAdded++;
            }

            // Check if rankings have changed. If so, revert point allotment.
            reversionResult = revertPointsThatChangeRankings(proposedResults, thisAnswerGroup, originalRanksByVotes, pointsAdded, remainingPoints);
            pointsAdded = reversionResult.pointsAdded;
            remainingPoints = reversionResult.remainingPoints;
          }
        }
      } while (remainingPoints > 0 && pointsAdded > 0);
      /*
      if (remainingPoints == 0) {
        log("******* SUCCESS! ALL POINTS DISTRIBUTED. ********");
      } else {
        log("UNABLE TO DISTRIBUTE " + remainingPoints + " POINT(S) WITHOUT ALTERING RANKINGS. DISTRIBUTION ABORTED.");
      }
      */
    }

    // Checks if point(s) that have been added by distributeRemainingPoints()
    // have altered rankings. If so, reverts the point(s) and returns the
    // new tallies for the number of points that have been distributed in
    // the current pass ("pointsAdded"), and the total number of points
    // awaiting distribution ("remainingPoints").
    function revertPointsThatChangeRankings (proposedResults, thisAnswerGroup, originalRanksByVotes, pointsAdded, remainingPoints) {
      var proposedPercentages = getPercentagesFromResults(proposedResults);
      var proposedRanks = getRanks(proposedPercentages);
      var answerIndex;
      var result;
      var newRank;
      var reversionResult;

      for (var i = 0; i < thisAnswerGroup.answers.length; i++) {
        answerIndex = indexOf(proposedResults, "index", thisAnswerGroup.answers[i]); // This result object's answer index in the original question
        result = proposedResults[answerIndex];  // A result object of the form {"index": n, "votes": n, "rank": n, "percentage": n}
        newRank = proposedRanks.indexOf(result.percentage) + 1;
        // log("New Proposed Percentages: " + proposedPercentages);
        // log("New Proposed Ranks: " + proposedRanks);
        // log(result.votes + " Original Proposed Rank: " + result.rank);
        // log(result.votes + " New Proposed Rank: " + newRank);
        if (pointsAdded > 0 && (originalRanksByVotes.length != proposedRanks.length || result.rank != newRank)) {
          // log("RANK CHANGED FOR ANSWER WITH VOTE COUNT " + result.votes + ". REMOVING POINT.");
          result.percentage -= 1;
          remainingPoints++;
          pointsAdded--;
        }
      }

      reversionResult = {"pointsAdded": pointsAdded, "remainingPoints": remainingPoints};
      return reversionResult;
    }

//==============================================================================
// UTILS
//==============================================================================

    // Returns the index of the object with the specified property value.
    function indexOf (array, prop, value) {
      for (var i = array.length; --i >= 0; ) {
        if (array[i][prop] == value) {
          return i;
        }
      }
      return -1;
    }

    // Sorts an array of objects by a given property.
    function sortByProp (array, prop, ascending) {
      array.sort(function(a,b){return ascending ? a[prop]-b[prop] : b[prop]-a[prop];});
    }

    // Returns a dense copy of the given array with all duplicate values removed.
    function unique (array) {
      var uniques = [];
      for (var i = array.length; --i >= 0;) {
        if (uniques.indexOf(array[i]) == -1) {
          uniques.push(array[i]);
        }
      }
      return uniques;
    }

    // Returns an array of individual percentages from a results set.
    function getPercentagesFromResults (results) {
      var percentages = [];

      for (var i = 0; i < results.length; i++) {
        percentages.push(results[i].percentage);
      }

      return percentages;
    }

    // Returns the numeric total of all elements in the supplied array
    function sum (array) {
      var len = array.length;
      var total = 0;

      for (var i = 0; i < len; i++) {
        total += array[i];
      }

      return total;
    }

    // Returns an array of floored integer percentages, where each element in the
    // returned array indicates its percentage of the total of all elements.
    // Example:
    //   toFlooredIntegerPercentages([7,7,7])
    //   Returns:
    //     [33,33,33]
    function toFlooredIntegerPercentages (array) {
      var total = sum(array);
      var percentages = [];

      for (var i = 0; i < array.length; i++) {
        percentages.push(Math.floor((array[i]/total)*100));
      }

      return percentages;
    }
    ///////////////////////////////////////////
    // END - PRETTY PERCENTAGE LIB
    ///////////////////////////////////////////